import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import routes from 'app/routes';
import CoachIcon from 'components/Common/Coaches/Widgets/Icon/Index';
import AvatarIcon from 'components/Members/Programs/Widgets/Info/AvatarIcon';

export default function CoachInfo({ program }) {
  const {
    status,
    coach,
    avatar,
    program_type: programType,
    possible_to_change_coach: possibleToChangeCoach,
  } = program.attributes;
  const cpaProgram = programType === 'cpa_only_program';

  if (cpaProgram) {
    return null;
  }

  if (!coach && !avatar) {
    if (status === 'completed') {
      return null;
    }

    return (
      <div className="mt-4 text-end fw-semibold">
        Start the program to select a coach
      </div>
    );
  }

  if (possibleToChangeCoach) {
    return (
      <div className="mt-4 text-end">
        <Link
          to={routes.members.programs.chooseNewCoach(program.id)}
          className="btn btn-outline-primary btn-sm btn-reverse"
        >
          Select New Coach
        </Link>
      </div>
    );
  }

  return (
    <div className="mt-3">
      {coach && (
      <CoachIcon
        coach={coach}
        bigIcon={false}
        contentClassName="small fw-semibold"
        wrapperClassName="justify-content-end"
      >
        {coach.full_name}
      </CoachIcon>
      )}

      {avatar && (
      <AvatarIcon
        avatar={avatar}
        bigIcon={false}
      />
      )}

    </div>
  );
}

CoachInfo.propTypes = {
  program: PropTypes.object.isRequired,
};
